import { render, staticRenderFns } from "./ProjectDocumentAccessScopeModal.vue?vue&type=template&id=536e4f4c"
import script from "./ProjectDocumentAccessScopeModal.vue?vue&type=script&lang=ts"
export * from "./ProjectDocumentAccessScopeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536e4f4c')) {
      api.createRecord('536e4f4c', component.options)
    } else {
      api.reload('536e4f4c', component.options)
    }
    module.hot.accept("./ProjectDocumentAccessScopeModal.vue?vue&type=template&id=536e4f4c", function () {
      api.rerender('536e4f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/ProjectDocumentAccessScopeModal.vue"
export default component.exports